import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { RotateCcwIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const factoryResetDefinition: SmartSignalDefinition<{
  factory_reset_timestamp?: IdEventV4['factory_reset_timestamp']
}> = {
  key: 'factory-reset',
  label: 'Factory reset',
  extract: (e) => ({ factory_reset_timestamp: e.factory_reset_timestamp }),
  icon: <RotateCcwIcon className='size-4' />,
  details(e) {
    return <CodeViewer value={formatJSON(this.extract(e))} withSearch={false} className='bg-gray-100' />
  },
  isDetected(e) {
    const p = this.extract(e)?.factory_reset_timestamp
    return typeof p === 'number' && p > 0
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"factory_reset_timestamp":',
  documentationHash: '#factory-reset-detection',
}
